// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gzfp","title":"styles_title__1Qzah"};